import api from "./api";

export async function getBlueprints(verticalKey = "") {
    const { data } = await api.get("/website-v2/admin/blueprints", {
        params: verticalKey ? { verticalKey } : {}
    });
    return data;
}

export async function getBlueprint(id) {
    const { data } = await api.get(`/website-v2/admin/blueprints/${id}`);
    return data;
}

export async function activateBlueprint(id) {
    const { data } = await api.post(
        `/website-v2/admin/blueprints/${id}/activate`
    );
    return data;
}

export async function archiveBlueprint(id) {
    const { data } = await api.post(
        `/website-v2/admin/blueprints/${id}/archive`
    );
    return data;
}

export async function updateBlueprint(id, payload) {
    const { data } = await api.put(
        `/website-v2/admin/blueprints/${id}`,
        payload
    );
    return data;
}

export async function validateBlueprint(payload) {
    const { data } = await api.post(
        "/website-v2/admin/blueprints/validate",
        payload
    );
    return data;
}

export async function getVerticalIntelligence() {
    const { data } = await api.get(
        "/website-v2/admin/vertical-intelligence"
    );
    return data;
}